import React, { useState } from 'react';
import PostAPI from '../../APICalls/PostAPI';
import './CorporateFeedback.css';

const CorporateFeedback = ({ currentFeedBackID, setFeedbackMenu, setCurrentFeedBackID, setShowFeedbackModal }) => {
  const [rating, setRating] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleRatingSelect = (index) => {
    if (rating === index) {
      setRating(null);
    } else {
      setRating(index);
      if (index === 0) {
        setSubmitted(true);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent page reload

    let environment = process.env.REACT_APP_NODE_ENV;
    let corporateFeedbackAPI;
    if (environment === "PRODUCTION" || environment === undefined) {
      corporateFeedbackAPI = process.env.REACT_APP_PROD_CORPORATEFEEDBACK;
    } else {
      corporateFeedbackAPI = process.env.REACT_APP_DEV_CORPORATEFEEDBACK;
    }

    const dataToPost = {
      orderID: currentFeedBackID,
      rating: rating + 1,
      comment: feedback,
    };

    // Submit feedback to the API
    PostAPI(corporateFeedbackAPI, dataToPost)
      .then((response) => {
        if (response.data.statusCode === 200) {
          setShowModal(true);
          setCurrentFeedBackID(null);
          setFeedbackMenu({});
          alert("Successfully submitted the feedback!!!");
        } else {
          alert("Failed to submit the feedback. Please try again later!!!");
          console.log(response);
        }
        setShowFeedbackModal(false); // Close the feedback modal
      })
      .catch((error) => {
        setShowFeedbackModal(false);
        alert("Failed to submit the feedback. Please try again later!!!");
        console.log(error);
      });
  };

  return (
    <div className="feedback-wrapper container p-4">
      <h2 className="text-primary mr-2">Did you enjoy your meal?</h2>
      <div className="rating-container d-flex justify-content-center">
        {Array.from({ length: 5 }, (_, index) => (
         <div key={index} className="rating-item mr-2" onClick={() => handleRatingSelect(index)} style={{ cursor: 'pointer' }}>
         <img
           src={rating !== null && index <= rating ? "https://d2nahbmqd5vvug.cloudfront.net/appdata/filledHeart.png" : "https://d2nahbmqd5vvug.cloudfront.net/appdata/outlineHeart.png"}
           width={35}
           height={35}
           alt="rating"
         />
       </div>
       
        ))}
        <button className="btn btn-primary ml-2" onClick={handleSubmit}>Submit</button>
      </div>
      {rating !== null && rating >= 0 && (
        <div className="feedback-container mt-4">
          <h4 className="text-primary">Thank you for your feedback!</h4>
          <p className="text-secondary">Let us know what went well and what could have been better</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <textarea
                className="form-control"
                rows={5}
                placeholder=""
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block">Submit</button>
          </form>
        </div>
      )}
      {showModal && (
        <div className={`modal fade show`} id="feedbackModal" tabIndex="-1" role="dialog" aria-labelledby="feedbackModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="feedbackModalLabel">Thank you for your feedback!</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                Your feedback has been submitted successfully!
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => setShowModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CorporateFeedback;
